export const DISPLAY_DATE_FORMAT = 'd MMM'
export const FUSION_DATE_FORMAT = 'dd-MM-yyyy'
export const NUM_OF_USP_TO_SHOW = 3
export const PETS_STAY_FREE_ID = '6554'
export const PRICE_FROM_NIGHTS = 7
export const PROPERTY_CALLOUT_BADGE_ID = '10638'
export const RESULTS_PAGE_SIZE = 12
export const SUMMARIES_API_TIMEOUT = 5000
export const DEFAULT_PAGE_NUMBER = 1
export const OPTIMIZELY_DATAFILE_CACHE_TTL = 60000 * 5 // 5 minutes
export const CONTENTFUL_CACHE_TTL = 60000 * 10 // 10 minutes

export const ALLOWED_GRADES = ['2', '3', '4', '5', 'P']

export const GRADE_CAT_IDS = {
  2: 'gradetwo',
  3: 'gradethree',
  4: 'gradefour',
  5: 'gradefive',
}

export const DEFAULT_SEARCH_LOCATION_URL = '/all-regions'

export const IMAGE_DOMAIN_AWAZE = 'https://img.chooseacottage.co.uk'
export const IMAGE_DOMAIN_NOVASOL = 'https://image.novasol.com'
export const IMAGE_DOMAIN_BASE_URL = 'https://img.chooseacottage.co.uk/Property'
export const IMAGE_WIDTH_AWAZE = 640
export const IMAGE_WIDTH_NOVASOL = 600

export const DEFAULT_IMAGE_URL =
  'https://img.chooseacottage.co.uk/Property/notFoundImage.png'

export const MAX_AUTOCOMPLETE_RESULTS = 100

export const DEFAULT_MAX_LEVEL_MAP_ZOOM = 16

export const CORRELATION_ID_COOKIE_NAME = 'awaze_correlation_id'

export const HOUR_TO_ALLOW_MAU_GENERATION_FROM = 5

export const COUNTRY_CODE_TO_TIMEZONE = {
  GB: 'Europe/London',
  DE: 'Europe/Berlin',
  FR: 'Europe/Paris',
  NL: 'Europe/Amsterdam',
  ES: 'Europe/Madrid',
  IT: 'Europe/Rome',
  NO: 'Europe/Oslo',
  SE: 'Europe/Stockholm',
  DK: 'Europe/Copenhagen',
  PL: 'Europe/Warsaw',
  HR: 'Europe/Zagreb',
}

export enum OPTIMIZELY_FLAGS_ENUM {
  AGE_SEARCH_MERCH_BANNER = 'search___explore_-_search_pdp_-_merch_banner_-_age-2001',
  AGE_SEARCH_REACTIVE_MERCH_BANNER = 'search___explore_-_search_pdp_-_reactive_merchandising_-_a_2f3se',
  AGE_MFE_ACTIVATE_PLACES_API = 'age_mfe_activate_places_api',
  AGE_SEARCH_IMAGE_PERFORMANCE = 'search___explore_-_search_-_performance__image_loading',
  AGE_SEARCH_RECOMMENDED_SORT_HOS = 'onesearch_search_explore_search_hoseasons_sort_AGE-2438',
  AGE_ACQUISITION_CHANGE_FLEX_ON_SEARCH_FROM_3_TO_1 = 'age_acquisition_change_flex_on_search_from_3_to_1',
  AGE_ACQUISITION_MEGA_MENU = 'age_acquisition_mega_menu',
  AGE_ACQUISITION_GOOGLE_FALLBACK_COT = 'age_acquisition_autocomplete_google_fallback_methods_cot',
  AGE_ACQUISITION_GOOGLE_FALLBACK_HOS = 'age_acquisition_autocomplete_google_fallback_methods_hos',
  AGE_ACQUISITION_GOOGLE_FALLBACK_NOV = 'age_acquisition_autocomplete_google_fallback_methods_nov',
  AGE_BLACK_FRIDAY_BANNER = 'age___search_and_book___countdown_banner_age_2631',
  AGE_COUNTDOWN_BANNER = 'search_explore_search_pdp_age-2693_uk_jan_2025_sale_banner',
  AGE_2732_POPULAR_FILTERS = 'search_explore_search_age-2732_popular_features',
  AGE_2784_REGION_VS_PLACES = 'search_explore_search_age-2784_places_v_region',
  AGE_2854_PROPERTY_CARD_IMAGE_SIZING = 'guest_discovery_AGE-2854_property_card_image_sizing',
  GD_3_WAS_NOW_UNDATED = 'guest_discovery_gd-3_was_now_pricing',
  GD_73_DRIVE_TIME_SEARCH = 'guest_discovery___gd-73___drive_time_search',
  GD_62_INCREASE_PROPERTIES_ON_SEARCH_PAGE = 'guest_discovery_gd-62_search_results_with_24_properties',
  GD_129_FLEXIDATE_SEARCH = 'guest_discovery_gd-129_flexidate_search',
  GD_128_ONESEARCH_V2 = 'guest_discovery_gd-128_onesearch_pim_v2',
  AGE_3003_PDP_SEARCH_ALTERNATIVE_LEAD_IMAGE = 'search_explore_pdp_search_age-3003_alternative_lead_image',
  GD_156_0_14_DAYS_SORT_ORDER_SEARCH = 'guest_discovery_gd-156_last_minute_search_0-14_days',
  GD_156_15_28_DAYS_SORT_ORDER_SEARCH = 'guest_discovery_gd-156_last_minute_search_15-28_days',
}

export const AGE_ACQUISITION_SEARCH_FORM_NEW_DESTINATION_LIST =
  'age_acquisition_search_form_new_destination_list'
export const WITH_FLEXIBILITY_SET_TO_1 = 'with_flexibility_set_to_1'
export const OPTIMIZELY_FLAGS = Object.values(OPTIMIZELY_FLAGS_ENUM)

export const AGE_SEARCH_MERCH_BANNER_VARIANTS = [
  'variant_a',
  'variant_b',
  'variant_c',
]

export const AGE_SEARCH_REACTIVE_MERCH_BANNER_VARIANTS = ['variant_a']

export const OPTIMIZELY_VARIANT_KEYS = {
  SHOW_WITH_MEGA_MENU: 'show_with_mega_menu',
  GOOGLE_FALLBACK_AUTOCOMPLETE: 'autocomplete_fallback',
  GOOGLE_FALLBACK_TEXTSEARCH: 'textsearch_fallback',
}

export const OPTIMIZELY_EVENTS = {
  PDP_CLICK_THROUGH: 'age_search_pdp_click_through',
  POPULAR_FEATURE_CLICK: 'age_search_popular_feature_interaction',
  FEATURE_CLICK: 'age_search_feature_interaction',
  NO_RESULTS: 'age_search_no_results',
  MAP_CLICK: 'age_guest_discovery_map_interaction',
  NEARBY_PROPERTIES_GEOLOCATION_ACCESS_DENIED:
    'search_form___near_by_properties___geolocation_access_denied',
  NEARBY_PROPERTIES_GEOLOCATION_ERROR:
    'search_form___near_by_properties___geolocation_error',
  NEARBY_PROPERTIES_SEARCH_FORM_SUBMITTED:
    'search_form___near_by_properties___search_submitted',
  SEARCH_FORM_SUBMITTED: 'search_form_submitted',
}

export const DEFAULT_MAX_STAY_DURATION = 365
export const UK_MAX_STAY_DURATION = 28
export const DEFAULT_RADIUS_KM = 10
export const GD_73_RADIUS_KM = 80

export const SORT_OPTIONS_ENUM = {
  RECOMMENDED: 'recommended',
  PRICE_ASCENDING: 'priceasc',
  PRICE_DESCENDING: 'pricedsc',
  SLEEPS_ASCENDING: 'sleepsasc',
  SLEEPS_DESCENDING: 'sleepsdsc',
  REVIEWS_DESCENDING: 'reviewsdsc',
  NO_SORT: 'nosort',
}
